(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["craft-showcase"] && !Shopify.designMode) return;
  try {
    
  /**
   * <craft-showcase-carousel>
   * Keeps the progress line in sync with the horizontal scroll position.
   * Re-initialises automatically when the section is re-rendered in the theme editor.
   */
  if (!customElements.get('craft-showcase-carousel')) {
    class CraftShowcaseCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.progress = this.querySelector('[data-progress]');
        this.thumb = this.querySelector('[data-progress-thumb]');

        if (!this.track || !this.progress || !this.thumb) return;

        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });

        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);

        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.update);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const maxScroll = scrollWidth - clientWidth;

        // Nothing to scroll: hide the progress line.
        this.progress.hidden = maxScroll <= 1;
        if (this.progress.hidden) return;

        const thumbWidth = 40; // matches the thumb width set in CSS (%)
        const progress = Math.abs(scrollLeft) / maxScroll;

        this.thumb.style.insetInlineStart = `${progress * (100 - thumbWidth)}%`;
      }
    }

    customElements.define('craft-showcase-carousel', CraftShowcaseCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
